function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9jcm9zcy1zbWFsbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiIuLi8uLi8uLi9zcmMvaWNvbnMvY3Jvc3Mtc21hbGwuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIENyb3NzU21hbGwoeyBzaXplLCBwcmltYXJ5Q29sb3IsIHRlc3RJZCB9KSB7XG4gIHJldHVybiAoXG4gICAgPHN2Z1xuICAgICAgY3NzPXt7XG4gICAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICAgIH19XG4gICAgICB3aWR0aD17c2l6ZX1cbiAgICAgIGhlaWdodD17c2l6ZX1cbiAgICAgIHZpZXdCb3g9XCIwIDAgMzIgMzJcIlxuICAgICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgICAgcm9sZT1cImltZ1wiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMjEuNzMxIDExLjI2OWEuOTE1LjkxNSAwIDAxMCAxLjI5NmwtMy45MzUgMy45MzQgMy45MzUgMy45MzZhLjkxNS45MTUgMCAxMS0xLjI5NiAxLjI5NkwxNi41IDE3Ljc5NWwtMy45MzUgMy45MzZhLjkxNC45MTQgMCAwMS0xLjI5NiAwIC45MTUuOTE1IDAgMDEwLTEuMjk2bDMuOTM0LTMuOTM2LTMuOTM0LTMuOTM0YS45MTUuOTE1IDAgMTExLjI5Ni0xLjI5NmwzLjkzNSAzLjkzNCAzLjkzNS0zLjkzNGEuOTE2LjkxNiAwIDAxMS4yOTYgMHpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5Dcm9zc1NtYWxsLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ3Jvc3NTbWFsbDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function CrossSmall(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M21.731 11.269a.915.915 0 010 1.296l-3.935 3.934 3.935 3.936a.915.915 0 11-1.296 1.296L16.5 17.795l-3.935 3.936a.914.914 0 01-1.296 0 .915.915 0 010-1.296l3.934-3.936-3.934-3.934a.915.915 0 111.296-1.296l3.935 3.934 3.935-3.934a.916.916 0 011.296 0z",
    fill: primaryColor
  }));
}

CrossSmall.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default CrossSmall;